import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { formatDate } from "../../shared/utility";
import showErrorModal from "../../components/modals/ModelErrorComponent";
import { ProgressSpinner } from "primereact/progressspinner";
import { sub } from "date-fns";

export default function InventoryManufacturedSubTable(props) {
  const {
    data,
    onManufacturedInventoryAdjusted,
    onManufacturedInventoryAdjustedByLot,
    loadingRows,
    subRowDetails,
    searchRef,
    developerMode,
  } = props;

  const packagingDateSubItemTemplate = (data) => {
    return formatDate(data.packaging_date);
  };

  const onCellEditComplete = (e) => {
    let { rowData, rowIndex, newValue, field, originalEvent: event } = e;

    if (rowData.is_demo === 1) {
      switch (field) {
        default:
          if (newValue.trim().length > 0) {
            onManufacturedInventoryAdjusted(rowData, rowIndex, newValue);
            rowData[field] = newValue;
          } else {
            event.preventDefault();
          }
          break;
      }
    } else {
      if (newValue > 0) {
        showErrorModal(
          "New amount must be 0 when adjusting inventory. Go to packaging and delete the item.",
        );
      } else {
        onManufacturedInventoryAdjustedByLot(rowData, rowIndex, newValue);
      }
    }
  };

  if (loadingRows[data.id + searchRef]) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const textEditor = (options) => {
    return (
      <InputText
        type="number"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        onKeyDown={(e) => e.stopPropagation()}
      />
    );
  };

  const unitPriceAmountSubItemTemplate = (data) => {
    return <div>${data.price}</div>;
  };

  const totalDollarAmountSubItemTemplate = (data) => {
    return <div>${data.total_dollar_amount}</div>;
  };

  const barcodesSubItemTemplate = (row) => {
    const barcodes = Array.isArray(row.barcodes)
      ? row.barcodes.filter((barcode) => barcode != null && barcode !== "")
      : [];

    if (barcodes.length === 0) {
      return <span className="text-[#64748B]">—</span>;
    }

    return (
      <div className="flex flex-col gap-1 font-mono text-xs text-[#0F172A]">
        {barcodes.map((barcode, index) => (
          <span key={`${barcode}-${index}`}>{barcode}</span>
        ))}
      </div>
    );
  };

  return (
    <div>
      <DataTable
        value={subRowDetails[data.id + searchRef]}
        tableClassName="min-w-full bg-white divide-y divide-gray-300 manufactured-inv-table-expanded-parent"
        cellClassName="py-2 bg-gray-100 border-1-bottom-gray px-2 text-sm"
        editMode="cell"
        dataKey="unique_id"
      >
        <Column field="lot_number" header="Product Lot" />
        {developerMode ? (
          <Column
            body={barcodesSubItemTemplate}
            header="Barcode"
            style={{ minWidth: "16rem" }}
          />
        ) : null}
        <Column body={packagingDateSubItemTemplate} header="Packaging Date" />
        <Column
          field="total_individual_units"
          header="Total Individual Units"
          class="align-right"
          style={{ textAlign: "right" }}
          editor={(options) => textEditor(options)}
          onCellEditComplete={onCellEditComplete}
        />
        <Column
          body={unitPriceAmountSubItemTemplate}
          header="Unit price"
          style={{ textAlign: "right" }}
        />
        <Column
          body={totalDollarAmountSubItemTemplate}
          header="Total Dollar Amount"
          style={{ textAlign: "right" }}
        />
      </DataTable>
    </div>
  );
}
